/**
 * 暖通专业的二级控制器的控制器类型编号
 */
export enum HVAC_CTRL_TYPE {
    ADD_HVAC_TUNNEL = 8000,
    ADD_HVAC_TUNNEL_CONNECT = 8001,
    ADD_HVAC_DEVICE_CONTROL = 8002,
}